import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FunctionalTableComponent from '../../components/table/FunctionalTableComponent';
import PaymentTransactionFormConfig from './PaymentTransactionFormConfig';
import CustomContainer from '../../components/CustomContainer';
import ExtendedPaymentTransactionTableConfig from './ExtendedPaymentTransactionTableConfig';
import { useFetchObject } from '../../components/hook/useFetchObject';
import PaymentTransactionStats from './PaymentTransactionStats';
import PaymentTransactionFilterConfig from './PaymentTransactionFilterConfig';
import Filters from '../../components/filter/Filters';

const PaymentTransactionsPage = () => {
  const navigate = useNavigate();
  const { data: transactions = [], ready, loadData } = useFetchObject('payment-transaction', []);
  const [filterValues, setFilterValues] = useState({});

  const filteredTransactions = useMemo(() => {
    if (!ready || !Array.isArray(transactions)) return [];

    return transactions.filter((t) => {
      const { transactionType, confirmed, paymentDate } = filterValues;

      if (
        Array.isArray(transactionType) &&
        transactionType.length &&
        !transactionType.includes(t.transactionType)
      ) {
        return false;
      }

      if (
        Array.isArray(confirmed) &&
        confirmed.length &&
        !confirmed.includes(t.confirmed)
      ) {
        return false;
      }

      if (paymentDate && (paymentDate.from || paymentDate.to)) {
        const txDate = new Date(t.paymentDate); // Zakładamy, że t.date to string
        const fromDate = paymentDate.from ? new Date(paymentDate.from) : null;
        const toDate = paymentDate.to ? new Date(paymentDate.to) : null;

        if (
          (fromDate && txDate < fromDate) ||
          (toDate && txDate > toDate)
        ) {
          return false;
        }
      }

      return true;
    });
  }, [transactions, filterValues, ready]);


  return (
    <CustomContainer title="Płatności">
      <Filters
        config={PaymentTransactionFilterConfig}
        value={filterValues}
        onChange={setFilterValues}
        className={"mb-3"}
      />

      <PaymentTransactionStats transactions={filteredTransactions} />

      <FunctionalTableComponent
        key={JSON.stringify(filteredTransactions)}
        shadow={false}
        title="Płatności"
        columns={ExtendedPaymentTransactionTableConfig}
        header
        initialData={filteredTransactions}
        removable
        modalSize="md"
        deleteApi="payment-transaction"
        createApi="payment-transaction"
        creationTitle="Dodanie płatności"
        withoutCreate
        creationFields={PaymentTransactionFormConfig}
        deleteModalTitle="Usunięcie płatności"
        deleteModalDescription="Czy na pewno chcesz usunąć płatność?"
        editable={false}
        onDeleted={loadData}
        width={12}
        tableExport={true}
      />
    </CustomContainer>
  );
};

export default PaymentTransactionsPage;
